import { useMediaQuery } from "./use-media-query";

/**
 * `true` on touch-primary devices (no hover, or a coarse pointer) — gates
 * hover-revealed affordances, which must be always-visible where CSS hover
 * never fires. Live: DevTools emulation and convertible laptops flip it
 * mid-session.
 */
export function useIsTouchDevice(): boolean {
  return useMediaQuery("(hover: none), (pointer: coarse)");
}
